import api from "~/utils/auth/api";

let redirects: { [x: number]: { fromLink?: string; toLink?: string; FromLink?: string; ToLink?: string } } = {};
export default defineNuxtRouteMiddleware(async (to) => {
	const { countryISOCode } = useISOCode();
	if (useNuxtApp().isHydrating) {
		await api<{ [x: number]: { fromLink?: string; toLink?: string; FromLink?: string; ToLink?: string } }>({
			url: `/cron/redirects/synapse/${countryISOCode.value}?api-version=1.0`,
			type: "config",
		}).then((res) => (redirects = res));
	}

	let redirect: { fromLink?: string; toLink?: string } = {};

	if (redirects) {
		Object.values(redirects).forEach(async (redir) => {
			if (redir.fromLink?.toLowerCase() === to.path?.toLowerCase() || redir.FromLink?.toLowerCase() === to.path?.toLowerCase()) {
				redirect = {
					fromLink: redir.fromLink || redir.FromLink,
					toLink: redir.toLink || redir.ToLink,
				};
			}
		});
	}

	if (!redirect.toLink || to.path === redirect.toLink) return;

	console.log(`Redirect - from ${to.path} to ${redirect.toLink}`);
	return navigateTo(redirect.toLink);
});
